import type { AbnDetails } from './abn-details.model';

export interface GenerateAbnDetailsOptions {
  readonly id?: string;
  readonly abn?: string;
  readonly isCurrentIndicator?: boolean;
  readonly entityStatusCode?: string;
  readonly entityStatusDescription?: string;
  readonly entityTypeCode?: string;
  readonly entityTypeDescription?: string;
  readonly replacedFrom?: string;
  readonly replacedIdentifierValue?: string;
  readonly entityStatusEffectiveFrom?: string;
  readonly entityStatusEffectiveTo?: string;
  readonly gstEffectiveFrom?: string;
  readonly gstEffectiveTo?: string;
  readonly stateCode?: string;
  readonly postcode?: string;
  readonly addressEffectiveFrom?: string;
  readonly addressEffectiveTo?: string;
  readonly recordLastUpdatedDate?: string;
  readonly otherTradingNames?: readonly string[];
  readonly businessNames?: readonly string[];
  readonly mainName?: string;
  readonly mainNameEffectiveFrom?: string;
  readonly asicNumber?: string;
  readonly givenName?: string;
  readonly otherGivenName?: string;
  readonly familyName?: string;
  readonly legalNameEffectiveFrom?: string;
  readonly legalNameEffectiveTo?: string;
  readonly mainTradingName?: string;
  readonly mainTradingNameEffectiveFrom?: string;
}

export function generateAbnDetailsObject({
  id,
  abn = '84628757059',
  isCurrentIndicator = true,
  entityStatusCode = 'Active',
  entityStatusDescription = '',
  entityTypeCode = 'PRV',
  entityTypeDescription = 'Australian Private Company',
  replacedFrom,
  replacedIdentifierValue,
  entityStatusEffectiveFrom = '2015-07-01',
  entityStatusEffectiveTo,
  gstEffectiveFrom = '2015-07-01',
  gstEffectiveTo,
  stateCode = 'NSW',
  postcode = '2000',
  addressEffectiveFrom = '2015-07-01',
  addressEffectiveTo,
  recordLastUpdatedDate = '2023-01-01',
  otherTradingNames = [],
  businessNames = [],
  mainName = 'LOADSHIFT PTY LTD',
  mainNameEffectiveFrom = '2015-07-01',
  asicNumber = '123456789',
  givenName,
  otherGivenName,
  familyName,
  legalNameEffectiveFrom,
  legalNameEffectiveTo,
  mainTradingName,
  mainTradingNameEffectiveFrom,
}: GenerateAbnDetailsOptions = {}): AbnDetails {
  return {
    id: id ?? abn,
    abn,
    isCurrentIndicator,
    entityStatusCode,
    entityStatusDescription,
    entityTypeCode,
    entityTypeDescription,
    replacedFrom,
    replacedIdentifierValue,
    entityStatusEffectiveFrom,
    entityStatusEffectiveTo,
    gstEffectiveFrom,
    gstEffectiveTo,
    stateCode,
    postcode,
    addressEffectiveFrom,
    addressEffectiveTo,
    recordLastUpdatedDate,
    otherTradingNames,
    businessNames,
    mainName,
    mainNameEffectiveFrom,
    asicNumber,
    givenName,
    otherGivenName,
    familyName,
    legalNameEffectiveFrom,
    legalNameEffectiveTo,
    mainTradingName,
    mainTradingNameEffectiveFrom,
  };
}
